import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { NavLink } from '../../components';
import { makeStyles } from '@material-ui/core/styles';
import { Toolbar } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';

const itemKeyList = [
  'productsManagement',
  'batchUpload',
  'listOfValues',
  'usersManagement',
];

const itemKeyTextMap = {
  productsManagement: 'Products Management',
  batchUpload: 'Batch Upload',
  listOfValues: 'List of Values',
  usersManagement: 'Users Management',
};

const itemKeyPathMap = {
  productsManagement: '/products',
  batchUpload: '/upload',
  listOfValues: '/values',
  usersManagement: '/users',
};

const itemKeyIconMap = {
  productsManagement: <DeveloperBoardIcon />,
  batchUpload: <CloudUploadIcon />,
  listOfValues: <ListAltIcon />,
  usersManagement: <PeopleAltIcon />,
};

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

export default () => {
  useRouteMatch();

  const {
    location: { pathname },
  } = document;
  const classes = useStyles();

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Toolbar />
      <div className={classes.drawerContainer}>
        <List>
          {itemKeyList.map((key) => (
            <NavLink key={key} to={itemKeyPathMap[key]}>
              <ListItem
                button
                key={key}
                selected={pathname.startsWith(itemKeyPathMap[key])}
              >
                <ListItemIcon>{itemKeyIconMap[key]}</ListItemIcon>
                <ListItemText primary={itemKeyTextMap[key]} />
              </ListItem>
            </NavLink>
          ))}
        </List>
      </div>
    </Drawer>
  );
};
